import { faqItems } from "@/data/faq";

interface FAQSchemaProps {
	limit?: number;
}

/**
 * SchemaFAQ Component
 *
 * Adds FAQPage structured data (JSON-LD) to help search engines
 * understand FAQ content and potentially display FAQ rich snippets.
 *
 * @param limit - Optional limit on number of FAQs to include (default: all)
 */
const SchemaFAQ = ({ limit }: FAQSchemaProps = {}) => {
	const faqsToInclude = limit ? faqItems.slice(0, limit) : faqItems;

	const schemaData = {
		"@context": "https://schema.org",
		"@type": "FAQPage",
		mainEntity: faqsToInclude.map((faq) => ({
			"@type": "Question",
			name: faq.question,
			acceptedAnswer: {
				"@type": "Answer",
				text: faq.answer,
			},
		})),
	};

	return (
		<script
			type="application/ld+json"
			// biome-ignore lint/security/noDangerouslySetInnerHtml: <>
			dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
		/>
	);
};

export default SchemaFAQ;
